import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles from './tags.module.scss'

const Tags = ({ tags }) => (
  <div className={styles.TagContainer}>
    <div className={styles.TagItem}>
      <Image src={`${assetLoader()}/images/ackoDriveTag.svg`} alt="AckoDriveTag Icon" width="16" height="16" />
      <span className={styles.TagText}>Tags</span>
    </div>
    {tags?.map(tag => (
      <div className={styles.TagItem} key={tag?.name}>
        <span>{tag?.name?.replace(/[-]/gi, ' ')}</span>
      </div>
    ))}
  </div>
)

export default Tags
